export enum SecurityLevelEnum {
  EditApplicationSetting,
  AddEmployee,
  EditEmployee,
  DeleteEmployee,
  EmployeeList,
  AddDepartment,
  EditDepartment,
  DeleteDepartment,
  DepartmentList,
  AddContactType,
  EditContactType,
  DeleteContactType,
  ContactTypeList,
  AddTag,
  EditTag,
  DeleteTag,
  TagList,
  AddProject,
  EditProject,
  DeleteProject,
  ProjectList,
  AddCustomerEmployee,
  EditCustomerEmployee,
  DeleteCustomerEmployee,
  CustomerEmployeeList,
  AddCustomer,
  EditCustomer,
  DeleteCustomer,
  CustomerList,
  AddTicketType,
  EditTicketType,
  DeleteTicketType,
  TicketTypeList,
  AddTicket,
  EditTicket,
  DeleteTicket,
  TicketList,
  AddSubTask,
  EditSubTask,
  DeleteSubTask,
  UpdateTicketStatus,
  UpdateAssignee,
  TeamLead,
  AddCountry,
  EditCountry,
  DeleteCountry,
  CountryList,
  AddProvince,
  EditProvince,
  DeleteProvince,
  ProvinceList,
  AddDistrict,
  EditDistrict,
  DeleteDistrict,
  DistrictList,
  AddBusinessRole,
  EditBusinessRole,
  DeleteBusinessRole,
  BusinessRoleList,
  AllowStatusChange,
  AddTakeLeave,
  EditTakeLeave,
  DeleteTakeLeave,
  TakeLeaveList,
  AddOfficeEquipmentType,
  EditOfficeEquipmentType,
  DeleteOfficeEquipmentType,
  OfficeEquipmentTypeList,
  AddOfficeEquipment,
  EditOfficeEquipment,
  DeleteOfficeEquipment,
  OfficeEquipmentList,
  AddOfficeEquipmentBrand,
  EditOfficeEquipmentBrand,
  DeleteOfficeEquipmentBrand,
  OfficeEquipmentBrandList,
  AddOfficeEquipmentModel,
  EditOfficeEquipmentModel,
  DeleteOfficeEquipmentModel,
  OfficeEquipmentModelList,
  AddProjectChecklist,
  EditProjectChecklist,
  DeleteProjectChecklist,
  ProjectChecklistList,
  AddStartProject,
  DeleteStartProject,
  StartProjectList,
  UpdateAssigneeForStartProject,
  AddStartProjectDetail,
  EditStartProjectDetail,
  DeleteStartProjectDetail,
  UpdateAssigneeForStartProjectDetail,
  UpdateProjectStatus,
  ProjectCompletionOrOngoing,
  AddMeetingRoom,
  EditMeetingRoom,
  DeleteMeetingRoom,
  MeetingRoomList,
  AddMeetingRoomSchedule,
  EditMeetingRoomSchedule,
  DeleteMeetingRoomSchedule,
  MeetingRoomScheduleList,
  AddCargoIntegration,
  EditCargoIntegration,
  DeleteCargoIntegration,
  CargoIntegrationList,
  AddERP,
  EditERP,
  DeleteERP,
  ERPList,
  AddModule,
  EditModule,
  DeleteModule,
  ModuleList,
  AddVirtualPos,
  EditVirtualPos,
  DeleteVirtualPos,
  VirtualPosList,
  AllowCloseTicket
}
